import type { Insets } from "./rotated-fit.ts";

/** Extra breathing room around the reserved toolbar / attribution strips when framing a route. */
export const EMBED_MAP_FIT_MARGIN_PX = 8;

/** Home map quest framing: looser than embed maps (~one zoom step with panel insets). */
export const HOME_QUEST_FIT_MARGIN_PX = 56;

/** Fallback top reserve when the toolbar is not measured yet (28px control + 6px inset × 2). */
export const EMBED_MAP_TOOLBAR_FALLBACK_PX = 40;

/** Fallback bottom reserve for the attribution line. */
export const EMBED_MAP_ATTRIB_FALLBACK_PX = 16;

export function embedStripFitPadding(topPx: number, bottomPx: number, margin = EMBED_MAP_FIT_MARGIN_PX): Insets {
  return {
    top: topPx + margin,
    right: margin,
    bottom: bottomPx + margin,
    left: margin,
  };
}

export function addFitMargin(insets: Insets, margin = EMBED_MAP_FIT_MARGIN_PX): Insets {
  return {
    top: insets.top + margin,
    right: insets.right + margin,
    bottom: insets.bottom + margin,
    left: insets.left + margin,
  };
}
